export const generateHTMLFromTextArea = (text, link) => {
    let result = '<p>' + text + (link ? ` <a href=${link}>Visa mer</a>` : '') + '</p>';
    result = result.replace(/\r\n\r\n/g, '</p><p>').replace(/\n\n/g, '</p><p>');
    result = result.replace(/\r\n/g, '<br />').replace(/\n/g, '<br />');
    return result;
};
